export default "__VITE_ASSET__CJnqMw4x__"